export default "__VITE_ASSET__DDA1Bnzn__"